"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const surface_1 = require("../../../../../../surface");
const utils_1 = require("./utils");
const withInlineValidation_1 = __importDefault(require("../../../../../wrappers/withInlineValidation"));
const links_1 = require("../../../../../utils/links");
const nums = new Set(['number', 'integer']);
const SelectMenu = ({ id, options, onChange, schema, value = '', disabled = false, invalid, formContext }) => {
    const inputOptions = react_1.useMemo(() => {
        const optionsMapped = options.enumOptions.map(({ value, label }) => ({
            label,
            value
        }));
        return optionsMapped;
    }, [options]);
    const processValue = value => {
        if (value === undefined)
            return undefined;
        // 'enum' is a reserved word, so only 'type' and 'items' can be destructured
        const { type, items } = schema;
        if (value === '') {
            return undefined;
        }
        if (type === 'array' && items && nums.has(items.type)) {
            return value.map(utils_1.asNumber);
        }
        if (type === 'boolean') {
            return value === 'true';
        }
        if (type === 'number') {
            return utils_1.asNumber(value);
        }
        // If type is undefined, but an enum is present, try and infer the type from
        // the enum values
        if (schema.enum) {
            if (schema.enum.every(x => utils_1.guessType(x) === 'number')) {
                return utils_1.asNumber(value);
            }
            if (schema.enum.every(x => utils_1.guessType(x) === 'boolean')) {
                return value === 'true';
            }
        }
        return value;
    };
    const handleChange = (newValue) => onChange(processValue(newValue));
    // check if the widget is locked because of forms links
    const isLocked = links_1.isLockedWidget(id, formContext.links);
    return (jsx_runtime_1.jsx(surface_1.SmartDropdown, { id: id, options: inputOptions, value: value, onSelect: handleChange, label: schema.title, disabled: disabled || isLocked, invalid: invalid, shadows: true }, void 0));
};
exports.SelectMenu = SelectMenu;
exports.default = withInlineValidation_1.default(exports.SelectMenu);
//# sourceMappingURL=index.js.map